import React from "react";
import "./HeroBackgroundGradient.css";

const BackgroundGradient = ({ sideFade }) => (
  <div className={"gradient-container" + (sideFade ? " side" : "")} />
);

export default BackgroundGradient;
